import React from "react";
import {MultiSelect} from "primereact/multiselect";

const DCStatusFilter = ({statusList,selectedStatus,tags, onchange}) => {

    const onFilter = (e) => {
        if (onchange !== undefined)
            onchange(tags, e.value)
    };
    return <MultiSelect value={selectedStatus} options={statusList}
                        onChange={onFilter}
                        optionLabel="name" placeholder="Select a status" className="p-column-filter"/>;

}

export default DCStatusFilter;
